<div class="container">
    <ngb-alert *ngIf="error && !interfaz" class="alert alert-danger"> 
        {{mensajeError}}
    </ngb-alert>
    <div class="card" *ngIf="interfaz">
        <div *ngIf="!error && !chequearInterfazAsientos(interfaz) && !chequearInterfazCENIT(interfaz)">
            <div class="card-header">
                <h3>{{interfaz.nombre}}</h3>
            </div>
            <div *ngIf="interfaz.nombre !== 'Monitor Documentos Contabilizados' && interfaz.nombre !== 'CENIT clientes'" class="card-body">
                <div class="card">
                    <div class="card-header">
                        <h4>Registros con error</h4>
                    </div>
                    <div class="card-body scrollCard">
                        <table *ngIf="interfaz.error.registros.length !== 0 && !error" class="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th *ngFor="let i of interfaz.error.encabezados">{{i}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let p of interfaz.error.registros; let i = index;">
                                    <th *ngFor="let r of interfaz.error.registros[i]">{{r}}</th>
                                </tr>
                            </tbody>
                        </table>
                        <ngb-alert type="warning" *ngIf="interfaz.error.registros.length == 0 && !error" class="alert alert-warning">
                            Sin información para mostrar
                        </ngb-alert>
                    </div>
                </div>
                <div class="card mt-2">
                    <div class="card-header">
                        <h4>Registros pendientes de envío</h4>
                    </div>
                    <div class="card-body scrollCard">
                        <table *ngIf="interfaz.pendientes.registros.length !== 0 && !error"
                            class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th *ngFor="let i of interfaz.pendientes.encabezados">{{i}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let p of interfaz.pendientes.registros; let i = index;">
                                    <th *ngFor="let r of interfaz.pendientes.registros[i]">{{r}}</th>
                                </tr>
                            </tbody>
                        </table>
                        <ngb-alert type="warning" *ngIf="interfaz.pendientes.registros.length == 0 && !error"
                            class="alert alert-warning">
                            Sin información para mostrar
                        </ngb-alert>
                    </div>
                </div>
            </div>
        </div>

        
        <div class="card-body" *ngIf="chequearInterfazAsientos(interfaz)">
            <div class="card">
                <div class="card-header">
                    <h4>Filtros</h4>
                </div>
                <div class="card-body">
                    <div class="input-group row align-items-center">
                        <div class="col-sm-4">
                            <div class="input-group">
                                <input type="date" [ngModel]="model" class="form-control form-control-rounded"
                                    placeholder="aaaa-mm-dd" (ngModelChange)="model = $event" name="dt" ngbDatepicker
                                    #d="ngbDatepicker" value="model" class="form-control form-control-rounded"
                                    #searchDate required readonly>
                                <button id="botonDesde" type="button" class="btn btn-secondary" (click)="d.toggle()">
                                    <i class="fa fa-calendar" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-sm-8 d-flex align-items-center">
                            <button [disabled]="cargandoAsientos"
                                class="btn btn-outline-primary ms-2 d-flex align-items-center justify-content-center p-0"
                                style="width: 40px; height: 40px;" (click)="cargarAsientos()">
                                <i *ngIf="!cargandoAsientos" class="fa fa-refresh text-primary"
                                    ngbTooltip="Cargar asientos"></i>
                                <i *ngIf="cargandoAsientos" class="fa fa-spinner fa-spin text-primary"
                                    ngbTooltip="Cargar asientos"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-2">
                <div class="card-header">
                    <h4>Registros obtenidos</h4>
                </div>
                <div class="card-body scrollCard">
                    <div *ngIf="this.asientos.length !== 0 && !errorAsientos" class="form-inline me-2">
                        <div class="row">
                            <div class="col-3">
                                <input id="busquedaAsientosFormControl" type="text" class="form-control col-6"
                                placeholder="Número documento SAP" [formControl]="buscadorAsientosFormControl"
                                (input)="filtrarAsientosPorNroSAP()" />
                            </div>
                            <div class="col-9">
                                <label for="checkboxRechazados" class="me-2 col-form-label"> Solo rechazados </label>
                                <input id="checkboxRechazados" class="mt-2 form-check-input" type="checkbox" [(ngModel)]="mostrarAsientosRechazados" (change)="chequearListaAsientosRechazados()" />
                            </div>
                        </div>
                    </div>
                    
                    <table *ngIf="this.asientos.length !== 0 && !errorAsientos" class="table table-striped" style="border-top: solid;
                    margin-top: 1em;">
                        <thead>
                            <tr>
                                <th>
                                    Número Idoc
                                </th>
                                <th>
                                    Número documento SAP
                                </th>
                                <th>
                                    Fecha creación
                                </th>
                                <th>
                                    Hora creación
                                </th>
                                <th>
                                    Estado
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let a of asientosAMostrar">
                                <th>
                                    {{a.NroIdoc}}
                                </th>
                                <th>
                                    {{a.STAPA1}}
                                </th>
                                <th>
                                    {{a.FechaCreacion}}
                                </th>
                                <th>
                                    {{a.HoraCreacion}}
                                </th>
                                <th>
                                    {{a.Status == 53 ? 'OK' : 'ERROR'}}
                                </th>
                            </tr>
                        </tbody>
                    </table>
                    <ngb-alert type="warning" *ngIf="this.asientosAMostrar.length == 0 && !errorAsientos" class="alert alert-warning">
                        Sin información para mostrar
                    </ngb-alert>
                    <ngb-alert class="alert alert-danger" *ngIf="errorAsientos"> 
                        {{mensajeError}}
                    </ngb-alert>
                </div>
            </div>
        </div>

        <div class="card-body" *ngIf="chequearInterfazCENIT(interfaz)">
            <div class="card">
                <div class="card-header">
                    <h4>Filtros</h4>
                </div>
                <div class="card-body">
                    <div class="input-group row">
                        <div class="col-sm-4">
                            <div class="input-group">
                                <input id="buscadorCENITFormControl" type="text" [disabled]="cargandoCliente" class="form-control"
                                    placeholder="Número CUIT" [formControl]="buscadorCENITFormControl" />
                                    <div *ngIf="!validarFormatoCuit() && (buscadorCenit.dirty || buscadorCenit.touched) && buscadorCenit.value !== ''" class="alert alert-danger">
                                        El número de CUIT no tiene el formato correcto.
                                    </div>
                            </div>
                        </div>
                        <div class="col-sm-8 d-flex">
                            <button [disabled]="cargandoCliente || !validarFormatoCuit()"
                                class="btn btn-outline-primary ms-2 d-flex align-items-center justify-content-center p-0"
                                style="width: 40px; height: 40px;" (click)="obtenerClienteCENIT()">
                                <i *ngIf="!cargandoCliente" class="fa fa-refresh text-primary"
                                    ngbTooltip="Obtener datos del cliente"></i>
                                <i *ngIf="cargandoCliente" class="fa fa-spinner fa-spin text-primary"
                                    ngbTooltip="Cargar datos"></i>
                            </button>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="card mt-2">
                <div class="card-header">
                    <h4>Registros obtenidos</h4>
                </div>
                <div class="card-body scrollCard">

                    <table *ngIf="this.clienteCENIT && !errorCENIT" class="table table-striped" style="border-top: solid;
                    margin-top: 1em;">
                        <thead>
                            <tr>
                                <th>
                                    Razón Social
                                </th>
                                <th>
                                    Tipo documento
                                </th>
                                <th>
                                    Número documento
                                </th>
                                <th>
                                    Condición IVA
                                </th>
                                <th>
                                    Cuenta SAP
                                </th>
                                <th>
                                    Cuenta CTC
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>
                                    {{clienteCENIT.razonSocial}}
                                </th>
                                <th>
                                    {{clienteCENIT.tipoDocumentoDescripcion}}
                                </th>
                                <th>
                                    {{clienteCENIT.numeroDocumento}}
                                </th>
                                <th>
                                    {{clienteCENIT.condicionIva.descripcion}}
                                </th>
                                <th>
                                    {{clienteCENIT.ctaSap}}
                                </th>
                                <th>
                                    {{clienteCENIT.ctA_CTC}}
                                </th>
                            </tr>
                        </tbody>
                    </table>
                    <ngb-alert type="warning" *ngIf="!this.clienteCENIT && !errorCENIT" class="alert alert-warning">
                        Sin información para mostrar
                    </ngb-alert>
                    <ngb-alert class="alert alert-danger" *ngIf="errorCENIT"> 
                        {{mensajeError}}
                    </ngb-alert>
                </div>
            </div>
        </div>

    </div>

</div>